export const CATEGORY_KEYWORDS = {
    'Art': ['Illustration', 'Digital Art', 'Painting', 'Installations', 'Mixed Media', 'Public Art', 'Sculpture', 'Conceptual Art', 'Social Practice', 'Textiles', 'Video Art',],
    'Comics': ['Comic Books', 'Graphic Novels', 'Webcomics', 'Anthologies', 'Events',],
    'Crafts': ['Stationery', 'Pottery', 'Knitting', 'Candles', 'Woodworking', 'DIY', 'Embroidery', 'Weaving', 'Quilts', 'Crochet', 'Glass', 'Creative Works',],
    'Dance': ['Performances', 'Residencies', 'Workshops', 'Spaces', 'Performance Art',],
    'Design': ['Product Design', 'Graphic Design', 'Architecture', 'Civic Design', 'Interactive Design', 'Typography', 'Toys',],
    'Fashion': ['Accessories', 'Apparel', 'Childrenswear', 'Couture', 'Jewelry', 'Pet Fashion', 'Ready-to-wear', 'Footwear',],
    'Food': [`Food & Beverages`, `Restaurants`, `Bacon`, `Events`, `Farmer's markets`, `Community Gardens`, `Vegan`, `Food Trucks`, `Small Batch`, `Farms`, `Drinks`, `Restaurants`, `Cookbooks`, `Food trucks`,],
    'Film and Video': [`Web Series & TV Shows`, `Documentary`, `Webseries`, `Shorts`, `Drama`, `Animation`, `Thrillers`, `Horror`, `Music Videos`, `Romance`, `Movie Theaters`, `Family`, `Television`, `Experimental`, `Narrative Film`, `Fantasy`, `Action`,],
    'Games': ['Tabletop Games', 'Video Games', 'Mobile Games', 'Live Games', 'Playing Cards', 'Gaming Hardware', 'Puzzles',],
    'Journalism': ['Photo', 'Video', 'Print', 'Audio', 'Printing',],
    'Music': ['Electronic Music', 'Indie Rock', 'Rock', 'Hip-Hop', 'Pop', 'Jazz', 'World Music', 'Blues', 'Dance', 'Metal', 'Country ', 'Chiptune', 'Latin', 'Kids', 'Punk', 'Classical Music', 'Faith',],
    'Photography': ['Places', 'Fine Art', 'Nature', 'Animals', 'People', 'Photobooks',],
    'Publishing': [`Fiction`, `Publishing`, `Nonfiction`, `Art Books`, `Anthologies`, `Periodicals`, `Calendars`, `Children's Books`, `Translations`, `Literary Spaces`, `Podcasts Blogs & Vlogs`, `Literary Journals`, `Science Fiction`, `Young Adult`, `Poetry`, `Radio `, `Zines`, `Academic`, `Letterpress`,],
    'Theater': ['Musical', 'Immersive', 'Plays', 'Experimental', 'Festivals', 'Comedy', 'Spaces',],
    'Technology': ['Transportation', 'Flight', 'Apps', 'Web', 'Makerspaces', 'Sound', 'Wearables', 'Space Exploration', 'Fabrication Tools', 'Camera Equipment', 'Camera Gear', 'DIY Electronics', '3D Printing', 'Phones & Accessories', 'Gadgets', 'Software', 'Robots', 'Tech & Innovation', ],
}

export default [
    'Art',
    'Comics',
    'Crafts',
    'Dance',
    'Design',
    'Fashion',
    'Food',
    'Film and Video',
    'Games',
    'Journalism',
    'Music',
    'Photography',
    'Publishing',
    'Theater',
    'Technology',
]